import { render, staticRenderFns } from "./GroupOverviewGridComp.vue?vue&type=template&id=3985a196&scoped=true"
import script from "./GroupOverviewGridComp.vue?vue&type=script&lang=js"
export * from "./GroupOverviewGridComp.vue?vue&type=script&lang=js"
import style0 from "./GroupOverviewGridComp.vue?vue&type=style&index=0&id=3985a196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3985a196",
  null
  
)

export default component.exports